export const FundingProcessorTypes = Object.freeze({
    DEMOCRACY_ENGINE: 'de',
    ACT_BLUE: 'actblue',
    NONE: 'none',
});
    
export const ContributionTypes = Object.freeze({
    DONATIONS: 'donations',
    PLEDGES: 'pledges',
    MIXED: 'mixed',
});

export const Plans = Object.freeze({
    FREE: 'free',
    LOCAL: 'local',
    REGIONAL: 'regional',
    STATE_NATIONAL: 'state-national',
    CUSTOM: 'custom',
});